import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppLayout from "./layout/AppLayout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
// import Analytics from "./pages/Analytics";
import CitiesOverview from "./pages/CitiesOverview";
import SalesOverview from "./pages/SalesOverview";
// import PageUnderDevelopment from "./pages/PageUnderDevelopment";
// import PageNotFound from "./pages/PageNotFound";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public — no header */}
        <Route path="/" element={<Login />} />

        {/* All pages inside AppLayout — GlobalHeader appears on all */}
        <Route element={<AppLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/cities-overview" element={<CitiesOverview />} />
          {/* <Route path="/analytics"       element={<Analytics />} /> */}
          {/* <Route path="/operations" element={<Operations />} /> */}
          {/* <Route path="/finance"    element={<Finance />} /> */}
          <Route path="/sales-overview" element={<SalesOverview />} />
          {/* <Route path="/page-under-dev" element={<PageUnderDevelopment />} /> */}
          {/* <Route path="*" element={<PageNotFound />} /> */}
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
